export default __webpack_public_path__ + "list-on-window.png";